import * as angular from "angular";
import {IController, IQService} from "angular";
import * as _ from "lodash";
import {CommonsAlertsService} from "../../../commons/services/commons-alerts.service";
import {TeamModel} from "../../models/team.model";

export class TeamSelectComponent implements IController {

  selectedId: any;
  options: any[];
  optionIds: string[];
  isRequired: boolean;
  isDisabled: boolean;
  excludeIds: string[];
  ngPlaceholder: string;
  hasMembers: boolean;
  onChange: Function;

  private teamsRef: any;
  public selectedTeam: any;
  public selectedText: any;

  constructor(private $mdSelect, private $log, private $q: IQService, private commonsAlertsService: CommonsAlertsService,
              private $teams, private $mdPanel) {
    this.teamsRef = this.$teams();
  }

  $onInit() {
    this._setSelected();
  };

  $onChanges(changes) {
    if (changes.selectedId && !changes.selectedId.isFirstChange()) {
      this._setSelected();
    }
  };


  onShowPanel($event) {

    if (!!this.isDisabled) {
      return;
    }

    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.CENTER,
        this.$mdPanel.yPosition.BELOW // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.bringoz-select-input')
      .withAnimation(this.$mdPanel.animation.FADE);

    const selectedIdRef = this.selectedId;
    const optionsRef = this.options;
    const optionIdsRef = this.optionIds;
    const excludeIdsRef = this.excludeIds;
    const ngPlaceholderRef = this.ngPlaceholder;

    const queryMapRef = {
      hasMembers: this.hasMembers
    };

    const config = {
      attachTo: angular.element(document.body),
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: '<bringoz-select-filter-panel ' +
        'type="ctrl.typeRef" ' +
        'selected-id="ctrl.selectedIdsRef" ' +
        'options="ctrl.optionsRef" ' +
        'option-ids="ctrl.optionIdsRef" ' +
        'query-map="ctrl.queryMap" ' +
        'ng-placeholder="ctrl.ngPlaceholderRef" ' +
        'panel-ref="ctrl.mdPanelRef" ' +
        'exclude-ids="ctrl.excludeIdsRef">' +
        '</bringoz-select-filter-panel>',
      controller: function () {
        this.typeRef = 'team';
        this.selectedIdsRef = selectedIdRef;
        this.optionsRef = optionsRef;
        this.optionIdsRef = optionIdsRef;
        this.excludeIdsRef = excludeIdsRef;
        this.ngPlaceholderRef = ngPlaceholderRef;
        this.queryMap = queryMapRef;
      },
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: (panel, selectedId) => {
        if (selectedId === 'clickOutsideToClose' || selectedId === 'escapeToClose') {
          selectedId = selectedIdRef;
        }

        if (!selectedId) {
          this.onChange({team: undefined, id: undefined});
          panel.destroy();
        } else {
          if (!!this.options) {
            const team = _.find(this.options, (o) => {
              return o.id === selectedId;
            })
            this.onChange({team: team, id: selectedId});
            panel.destroy();
          } else {
            this.teamsRef.$asyncValues([selectedId])
              .then((teams: TeamModel[]) => {
                this.onChange({team: teams[0], id: selectedId});
                panel.destroy();
              });
          }
        }
      }
    };

    this.$mdPanel.open(config);
  }

  onResetFilter() {
    this.onChange({team: undefined});
  }

  private _setSelected() {
    if (!!this.selectedId) {
      if (!!this.options) {
        this.selectedTeam = _.find(this.options, (o) => {
          return o.id === this.selectedId;
        });
        this._setSelectedText();
      } else {
        this.teamsRef.$asyncValues([this.selectedId])
          .then((teams: TeamModel[]) => {
            this.selectedTeam = _.orderBy(teams, ['name'], ['asc'])[0];
            this._setSelectedText()
          });
      }
    } else {
      this.selectedTeam = undefined;
      this._setSelectedText()
    }
  }

  private _setSelectedText() {
    this.selectedText = _.get(this.selectedTeam, 'name', '');
  }


}

angular
  .module('bringoz.admin.teams')
  .component('teamSelect', {
    require: {
      form: '^form'
    },
    bindings: {
      selectedId: '<',
      options: '<?',
      optionIds: '<?',
      isRequired: '<?',
      isDisabled: '<?',
      excludeIds: '<?',
      hasMembers: '<?',
      ngPlaceholder: '@?',
      onChange: '&',
    },
    template: require('./team-select.html').default,
    controller: TeamSelectComponent
  });
